export default "__VITE_ASSET__CYeLnar9__"